import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, info: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info)
    this.setState({ info })
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'60vh', padding:24 }}>
        <div style={{ textAlign:'center', maxWidth:440 }}>
          <div style={{ fontSize:36, marginBottom:16, opacity:.3 }}>⚠</div>
          <div style={{ fontSize:17, fontWeight:650, marginBottom:8 }}>Something went wrong</div>
          <div style={{ fontSize:13, color:'var(--text3)', marginBottom:24, lineHeight:1.6 }}>
            An unexpected error occurred. Try refreshing the page — if the problem persists, contact support.
          </div>
          <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
            <button className="btn btn-primary" onClick={() => window.location.reload()}>
              Refresh page
            </button>
            <button className="btn" onClick={() => this.setState({ hasError: false, error: null, info: null })}>
              Try again
            </button>
          </div>
          {/* Shown in production too.
              This said "an unexpected error occurred" and hid the one fact that
              identifies the fault, because the detail was behind a NODE_ENV
              check and the built bundle is production. A seller reporting a
              crash could only send a screenshot of a shrug, and finding it meant
              guessing at which of a dozen components threw. The message is not
              secret — it is a JavaScript error, and it is the difference between
              a fix in one step and a fix in ten. */}
          {this.state.error && (
            <details style={{ marginTop:20, textAlign:'left' }}>
              <summary style={{ fontSize:12, color:'var(--text3)', cursor:'pointer' }}>
                What went wrong
              </summary>
              <pre style={{ marginTop:8, fontSize:11, background:'var(--bg3)',
                            border:'1px solid var(--border)', borderRadius:6, padding:12,
                            overflowX:'auto', color:'var(--red)', whiteSpace:'pre-wrap' }}>
                {this.state.error.toString()}
                {this.state.info?.componentStack
                  ? `\n\nIn:${this.state.info.componentStack.split('\n').slice(0, 6).join('\n')}`
                  : ''}
              </pre>
              <button className="btn btn-sm" style={{ marginTop:8 }}
                onClick={() => {
                  const text = `${this.state.error}\n${this.state.info?.componentStack || ''}`
                  navigator.clipboard?.writeText(text).catch(() => {})
                }}>
                Copy for support
              </button>
            </details>
          )}
        </div>
      </div>
    )
  }
}
